module.exports = __webpack_public_path__ + "static/media/sparkle-icon.7d2bde1a.svg";